import accounting from 'accounting';
import Bignumber from 'bignumber.js';
// import moment from 'vue-moment';
import moment from 'moment';

function errorHandling(error) {
  var listError = [];
  if(error.status > 200 && error.status <= 300) {
    /* request success but the http status code is not 200 */
    listError.push('HTTP status code : '+error.status+ ' (invalid)')
  } else if(error.response) {
    if (error.response.data.reason){
      listError.push(error.response.data.reason);
    } else {
      listError.push('Error '+error.response.status+(error.response.data.message?' - '+error.response.data.message:''));
    }
  } else {
    listError.push(error.message);
  }
  if(listError.length == 0){
    listError.push('System Error');
  }
  return listError;
}

//function maptableColumn(listItem, fieldLabels, isNeedAction, isFilterOptions){
//  let listFields = [];
//  if(isFilterOptions == true){
//    listFields.push({value: '', label: '-'})
//  }
//  if(listItem.length){
//    Object.keys(listItem[0]).forEach((key) => {
//      if(Object.keys(fieldLabels).includes(key)){
//        listFields.push({ key: key, value: key, label: fieldLabels[key]})
//      }
//    })
//    if(isNeedAction){
//      listFields.push({ key: 'Action', label: ''});
//    }
//    return listFields;
//  } else {
//   return null
//  }
//}

function convertNullField(listItem){
  let timeFields = [
    'startProcessTime',
    'officeEndWorkTime',
    'officeStartWorkTime',
    'bookingDate',
    'endTime',
    'startTime',
    'createdAt',
    'updatedAt',
    'holdEnd',
    'holdStart',
    'end',
    'start',
  ];
  try {
    if(listItem.length){
      let listKey = Object.keys(listItem[0]);

      for(const item of listItem) {
        listKey.forEach((key) => {
          if(item[key] == null || item[key].length == 0) { item[key] = '-'}
          if (timeFields.includes(key)){
            item[key] = getIndoTime(item[key]);
          }
        })
      }

      // listKey.forEach((key) => {
      //   console.log(key)
      //   for (const item of listItem) {
      //     if(item[key] == null || item[key].length == 0) { item[key] = '-'}
      //     if (timeFields.includes(key)){
      //       item[key] = getIndoTime(item[key]);
      //     }
      //   }
      // })
    } return listItem;
  } catch (error){
    return listItem;
  }
}

function exclusiveNumberOnly(input){
  let reg = /^[0-9]*$/
  return reg.test(input);
}

function getIndoTime(datetime){
  let time = new Date(datetime);
  if (isNaN(time)){
    return datetime;
  } else if(datetime == null){
    return '-';
  } else {
    let date = time.getDate();
    let month = time.getMonth()+1;
    let hour = time.getHours();
    let minute = time.getMinutes();
    let second = time.getSeconds();
    second < 10 ? second = '0' + second.toString() : second = second.toString();
    minute < 10 ? minute = '0' + minute.toString() : minute = minute.toString();
    hour < 10 ? hour = '0' + hour.toString() : hour = hour.toString();
    date < 10 ? date = '0' + date.toString() : date = date.toString();
    month < 10 ? month = '0' + month.toString() : month = month.toString();
    return  date+'-'+ month +'-'+time.getFullYear()+' '+ hour +':' + minute + ':' + second;
  }
}
/*
function getIndoTime(itemDate){
  if(itemDate !== null){
    let dateObj = new Date(itemDate);
    let month = dateObj.getMonth()+1;
    if(month.toString().length == 1){
      month = '0'+ month;
    }
    let year = dateObj.getFullYear();
    let day = dateObj.getDate();
    if(day.toString().length == 1){
      day = '0'+ day;
    }
    let hours = dateObj.getHours();
    if(hours.toString().length == 1){
      hours= '0'+hours;
    }
    let minute = dateObj.getMinutes();
    if(minute.toString().length == 1){
      minute= '0'+minute;
    }
    let second = dateObj.getSeconds();
    if(second.toString().length == 1){
      second= '0'+second;
    }
    let result = day+'/'+month+'/'+year+ ' '+ hours+ ':'+minute+ ':'+ second;
    return result;
  } else {
    return '-'
  }
*/

  // let dateTemp = new Date(itemDate);
  // if(!isNaN(dateTemp.getDate())){
  //   itemDate = dateTemp.getDate() + '-' + (dateTemp.getMonth()+1) + '-' + dateTemp.getFullYear() +
  //   ' '+ dateTemp.getHours() + ':' + (dateTemp.getMinutes() < 10 ? '0'+dateTemp.getMinutes() : dateTemp.getMinutes()) + ':' + (dateTemp.getSeconds() < 10 ? '0'+dateTemp.getSeconds() : dateTemp.getSeconds());
  //   return itemDate;
  // } else {
  //   return '-'
  // }
//}

function toastSuccess(vue, msg, toastTitle='Sukses') {
  vue.$bvToast.toast(msg, {
      title: toastTitle,
      autoHideDelay: 5000,
      appendToast: true,
      variant: 'success'
  })
}

function toastError(vue, msg, toastTitle='Gagal') {
  vue.$bvToast.toast(msg, {
      title: toastTitle,
      autoHideDelay: 5000,
      appendToast: true,
      variant: 'danger'
  })
}

function parseError(vue, error, toastTitle = "Gagal") {

  if(error.response.status == 401) {
    return
  }

  let message = ""

  if(error.response && error.response.data.reason != null) {
    message = error.response.data.reason
  }
  else if(error.message.startsWith("timeout")) {
    message = "Gagal menghubungi server, periksa jaringan anda dan coba kembali!"
  }
  else {
    // message = error.message
    message = 'Mohon maaf terjadi kesalahan pada sistem. Silahkan mencoba kembali sesaat lagi!'
  }

  this.toastError(vue, message, toastTitle)
}

const ROLE_ID_KEYWORD = "fimsRoleId"

function isRole(roleId){
  if(localStorage.getItem(ROLE_ID_KEYWORD) == roleId) return true
  else return false
}

function isEmpty(data){
  // if null or undefined or empty string
  if(typeof data === 'undefined' || data === null || data === '' || data === 'null'){
    return true
  }
  // if of type array
  else if(typeof data.length !== 'undefined'){
    // if length of 0, empty
    if(data.length <= 0){
      return true
    }
  }
  return false
}

function objectHasSameData (obj1, obj2) {

  if (obj1 == null || obj2 == null) return false

  const obj1Length = Object.keys(obj1).length;
  const obj2Length = Object.keys(obj2).length;

  if (obj1Length === obj2Length) {
    return Object.keys(obj1).every(
      key => obj2.hasOwnProperty(key)
        && obj2[key] === obj1[key]);
  }
  return false;
}

function showData(data, type = "string"){
  if(type === "number"){
    return !(isEmpty(data)) ? Number(data).toLocaleString("id") : 0
  }
  else if(type === "string"){
    return !(isEmpty(data)) ? data : "-"
  }
  else if(type === "shortDate"){
    return !(isEmpty(data)) ? moment(data, "YYYY-MM-DD").format("DD/MM/YYYY") : "-"
  }
  else if(type === "shortTime"){
    return !(isEmpty(data)) ? moment(data, "H:mm:s").format("H:mm") : "00:00"
  }
  else if(type === "longTime"){
    return !(isEmpty(data)) ? moment(data, "H:mm:s").format("H:mm:ss") : "00:00"
  }
  else if(type === "longTimeFromLongDate"){
    return !(isEmpty(data)) ? moment(data, "YYYY-MM-DD H:mm:ss").format("H:mm:ss") : "00:00"
  }
  else if(type === "longDate"){
    return !(isEmpty(data)) ? moment(data, "YYYY-MM-DD H:mm:ss").format("Do MMMM YYYY") : "-"
  }
  else if(type === "longDateWithTime"){
    return !(isEmpty(data)) ? moment(data, "YYYY-MM-DD H:mm:ss").format("Do MMMM YYYY H:mm") : "-"
  }
  else{
    return !(isEmpty(data)) ? data : "-"
  }
}

function parseNumber(data){
  return data.toString().replace(/[^0-9]/g, '')
}

function parseNpwp(data){
  if(data.length > 2){
    if(data[2] !== '.'){
      data = data.slice(0, 2) + "." + data.slice(2)
    }
  }
  if(data.length > 6){
    if(data[6] !== '.'){
      data = data.slice(0, 6) + "." + data.slice(6)
    }
  }
  if(data.length > 10){
    if(data[10] !== '.'){
      data = data.slice(0, 10) + "." + data.slice(10)
    }
  }
  if(data.length > 12){
    if(data[12] !== '-'){
      data = data.slice(0, 12) + "-" + data.slice(12)
    }
  }
  if(data.length > 16){
    if(data[16] !== '.'){
      data = data.slice(0, 16) + "." + data.slice(16)
    }
  }
  if(data.length > 20){
    data = data.slice(0, 20)
  }
  // if(data[data.length-1] == "." || data[data.length-1] == "-"){
  //   data = data.slice(0, data.length-1)
  // }
  return data
}

export default {
  errorHandling,
  convertNullField,
  //maptableColumn,
  getIndoTime,
  exclusiveNumberOnly,
  toastSuccess,
  toastError,
  parseError,
  isRole,
  objectHasSameData,
  isEmpty,
  showData,
  parseNumber,
  parseNpwp,

  NUMBERS: [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9
  ],

  LETTER_SMALL: [
    'a', 'b', 'c', 'd', 'e', 'f', 
    'g', 'h', 'i', 'j', 'k', 'l', 
    'm', 'n', 'o', 'p', 'q', 'r', 
    's', 't', 'u', 'v', 'w', 'x', 
    'y', 'z'
  ],

  LETTER_CAPITAL: [
    'A', 'B', 'C', 'D', 'E', 'F', 
    'G', 'H', 'I', 'J', 'K', 'L', 
    'M', 'N', 'O', 'P', 'Q', 'R', 
    'S', 'T', 'U', 'V', 'W', 'X', 
    'Y', 'Z'
  ],

  getBasePagedQuery(page, size) {
    let params = {
      page: page,
      size: size
    }
    return params
  },

  getBaseSortQuery(sort, params) {
    params['sortBy'] = sort.by
    params['asc'] = !sort.desc
    return params
  },

  containsCapitalLetter(str) {
    var found = false

    for(const letter of this.LETTER_CAPITAL) {
      if(str.indexOf(letter) != -1) {
        found = true
        break
      }
    }

    return found
  },

  containsSmallLetter(str) {
    var found = false

    for(const letter of this.LETTER_SMALL) {
      if(str.indexOf(letter) != -1) {
        found = true
        break
      }
    }

    return found
  },

  containsNumber(str) {
    var found = false

    for(const number of this.NUMBERS) {
      if(str.indexOf(number) != -1) {
        found = true
        break
      }
    }

    return found
  },

  containsSpecialCharacter(str) {
    var specialChar = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~ ]/

    if (specialChar.test(str)) {
      return true
    } else{
      return false
    }
  },

  thousandSeparator(value, fixed=0, separator=".", decimal=","){

    if (value === 0) {
      return "0"
    } else if (this.isEmpty(value)) {
      return ""
    } else{
      value = value.toString()
      let splittedValue = value.split(decimal)

      // Show fixed decimal places according to the number
      if (fixed === -1) {
        if (value.split(separator).length > 1) {
          let decimalValue = value.split(separator)[1].toString()          
          if (decimalValue.length > 15) {
            fixed = 15
          } else{
            fixed = value.split(separator)[1].toString().length
          }

        } else{
          fixed = 0
        }
      }

      if (splittedValue.length > 1) { value = splittedValue[0] }
      let val = accounting.unformat(value)
          val = new Bignumber(val)
          val = accounting.formatNumber(val.toString(), fixed, separator, decimal)
      if (splittedValue.length > 1) { val = val + decimal + splittedValue[1] }
      return val
    }
  },

  normalizedNumber(value){
    if (value !== null && typeof value !== 'undefined') {
      return Number(value.toString().replace(/\./g, "").replace(/,/g, "."))
    } else{
      return ""
    }
  },
}
